import React from "react";
import { NavLink } from "react-router-dom";

import { Link as SLink, animateScroll as Scroll } from "react-scroll";

import "../css/nav.css";
const Nav = () => {
  let scrollPos = 0;

  window.addEventListener("scroll", () => {
    const width = window.innerWidth;

    const nav = width >= 1024 ?  document.getElementById("nav") : document.getElementById("nav--mobile");

    const scrollingDown = () => nav.classList.add("scrollingDown");
    const scrollingUp = () => nav.classList.remove("scrollingDown");

    document.body.getBoundingClientRect().top > scrollPos ? scrollingUp() : scrollingDown();

    scrollPos = document.body.getBoundingClientRect().top;
  });

  const onMainNav = () => {
    const [...itemsList] = document.getElementsByClassName("homeNav");
    itemsList.map((item) => item.classList.remove("active"));

    Scroll.scrollToTop();
    onHumburger();
  };

  const onHomeNav = (e) => {
    const clickedI = e.target;
    const urlOrigin = window.location.origin;
    const currPath = window.location.pathname;
    const secID = e.target.innerText.toLowerCase();
    const [...itemsList] = document.getElementsByClassName("homeNav");

    const activate = () => {
      itemsList.map((item) => item.classList.remove("active"));
      clickedI.classList.toggle("active");
    };

    return currPath === "/"
      ? activate()
      : window.location.replace(`${urlOrigin}/#${secID}`);
  };

  const onHumburger = () => {
    const mobileList = document.getElementById("mobileList");
    const humburger = document.getElementById("humburger");

    humburger.classList.toggle("humburger--active");
    mobileList.classList.toggle("nav--mobile__list--active");
  }

  return (
    <>
      <nav id="nav">
        <ul>
          <NavLink onClick={onMainNav} exact activeClassName="active" to="/">
            <li className="navItem">Home</li>
          </NavLink>
          <NavLink onClick={onMainNav} activeClassName="active" to="/about">
            <li className="navItem">My CV</li>
          </NavLink>
          <NavLink onClick={onMainNav} activeClassName="active" to="/portfolio">
            <li className="navItem">Portfolio</li>
          </NavLink>
        </ul>

        <span className="logo">
          <NavLink to="/">
            <h1 onClick={Scroll.scrollToTop}>Hossam Rabei</h1>
          </NavLink>
        </span>

        <ul>
          {/* NOTE: offset = 145 */}
          <SLink onClick={onHomeNav} smooth={true} to="services">
            <li className="homeNav">Services</li>
          </SLink>

          <SLink onClick={onHomeNav} smooth={true} to="skills">
            <li className="homeNav">Skills</li>
          </SLink>

          <SLink onClick={onHomeNav} smooth={true} to="testimonial">
            <li className="homeNav">Testimonial</li>
          </SLink>

          <SLink onClick={onHomeNav} smooth={true} to="contact">
            <li className="homeNav">Contact</li>
          </SLink>
        </ul>
      </nav>

      <nav id="nav--mobile">
        <span className="logo">
          <NavLink to="/">
            <h1 onClick={Scroll.scrollToTop}>Hossam Rabei</h1>
          </NavLink>
        </span>

        <div id="humburger" className="humburger" onClick={onHumburger}>
          <span className="bar1"></span>
          <span className="bar2"></span>
          <span className="bar3"></span>
        </div>
      </nav>

      <ul id="mobileList" className="nav--mobile__list">
        <NavLink onClick={onMainNav} exact activeClassName="active" to="/">
          <li className="navItem">Home</li>
        </NavLink>
        <NavLink onClick={onMainNav} activeClassName="active" to="/about">
          <li className="navItem">My CV</li>
        </NavLink>
        <NavLink onClick={onMainNav} activeClassName="active" to="/portfolio">
          <li className="navItem">Portfolio</li>
        </NavLink>
      </ul>
    
    </>
  );
};

export default Nav;
